<template>
  <div>
    <header-div v-if="isshow"></header-div>
    <orgheader-div v-else></orgheader-div>
    <div class="container">
      <div class="xieyi">
        <h2>法律政策、隐私保护政策</h2>
        <div class="xieyi-content">
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <strong><span style="font-family:宋体;color:black;background:white">版权</span></strong>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">zp.sttts.org.cn</span><span style="font-family:宋体;color:black;background:white">网站的内容、图表、版式设计等所呈现出的全部或部分可单独作为作品保护之内容等及维系本网站运营的各种源代码、执行程序、系统均受到中国版权法律、法规及相关国际条约的保护。zp.sttts.org.cn对上述内容拥有一切权利，未经zp.sttts.org.cn同意，不允许全部或部分复制、转载或以其他任何方式使用。禁止以任何目的重新使用zp.sttts.org.cn网上的内容和图表等作品或作品元素。在事先得到zp.sttts.org.cn许可，且未对内容和图表等作品、元素进行任何修改的情况下，zp.sttts.org.cn的网上材料可作为网外信息方面和非商业方面的用途。经zp.sttts.org.cn同意后复制、转载或者以其他形式使用本网站相关资料的，应当标明资料来源于“zp.sttts.org.cn”，以及zp.sttts.org.cn或相关第三方拥有该等资料的著作权的字样。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">申请使用zp.sttts.org.cn内容的许可是按逐个批准的原则进行的。zp.sttts.org.cn欢迎使用者提出申请。请把请求直接提交给info@zp.sttts.org.cn。请勿复制或采用zp.sttts.org.cn所创造的用以制成网页的HTML。HTML的版权同样属于zp.sttts.org.cn。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">对zp.sttts.org.cn网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权及其衍生的其他全部权利，对发布的信息均享有专有的发布和使用权。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <strong><span style="font-size:16px;font-family: 宋体;color:black;background:white">商标</span></strong>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">zp.sttts.org.cn</span><span style="font-size:16px;font-family:宋体;color:black;background:white">的商标，包括zp.sttts.org.cn、Alliance和zp.sttts.org.cn其他网站的商标属于zp.sttts.org.cn所有。zp.sttts.org.cn上业务合作者的商标属于合作者所有。未经zp.sttts.org.cn及/或zp.sttts.org.cn的合作者事先书面许可，任何人不得复制或以任何其他方式使用上述商标。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">&nbsp;</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <strong><span style="font-size:16px;font-family: 宋体;color:black;background:white">免责声明</span></strong>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-indent:0">
            <span style="font-size:16px;font-family:宋体;color:black">1、</span><span style="font-size:16px;font-family:宋体;color:black;background:white">使用者理解并同意zp.sttts.org.cn对以下情况免责：</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">1).</span><span style="font-family:宋体;color:black;background:white">应聘信息发布方对存入简历中心的个人简历及材料的格式、内容的真实性、准确性和合法性负有全部责任，招聘信息发布方对于其在职位数据库公布的材料的真实性、准确性和合法性负有全部责任zp.sttts.org.cn仅是提供职位发布等信息的平台，zp.sttts.org.cn不对应聘及招聘信息的真实性、有效性、准确性负责。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(2).zp.sttts.org.cn</span><span style="font-family:宋体;color:black;background:white">并不能时时监视此网址，但保留进行随时监视的权利。对于非zp.sttts.org.cn公布的材料，zp.sttts.org.cn一概不负任何责任。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(3).zp.sttts.org.cn</span><span style="font-family:宋体;color:black;background:white">虽然对用户进行资质审查，但zp.sttts.org.cn并非司法机关，仅能要求用户提交真实、有效的资质证明文件，并对该提交的资质证明文件进行审核。如用户提交虚假、伪造、变造文件的，zp.sttts.org.cn对此概不承担法律责任。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(4). zp.sttts.org.cn</span><span style="font-family:宋体;color:black;background:white">不对用户的线下行为负责。企业用户及个人用户均应审慎的对待他方之行为，因为他方之行为给用户造成任何不利影响的，zp.sttts.org.cn不承担任何法律责任。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(5) zp.sttts.org.cn</span><span style="font-family:宋体;color:black;background:white">不能保证某一种职位描述会有一定数目的使用者来浏览，也不能保证会有一位特定的使用者来浏览。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(6)zp.sttts.org.cn</span><span style="font-family:宋体;color:black;background:white">对由于政府禁令、现行生效的适用法律或法规的变更、火灾、地震、动乱、战争、停电、通讯线路中断、黑客攻击、计算机病毒侵入或发作、电信部门技术调整、因政府管制而造成网站的暂时性关闭等任何影响网络正常运营的不可预见、不可避免、不可克服和不可控制的事件（“不可抗力事件”），以及他人蓄意破坏、zp.sttts.org.cn工作人员的疏忽或不当使用，正常的系统维护、系统升级，或者因网络拥塞而导致zp.sttts.org.cn不能访问而造成的zp.sttts.org.cn所提供的信息及数据的延误、停滞或错误，以及使用者由此受到的一切损失不承担任何责任。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">(7)</span><span style="font-size:16px;font-family:宋体;color:black;background:white">由于与zp.sttts.org.cn链接的其他网站或用户所使用的网络运营商所造成之个人资料泄露及由此而导致的任何法律争议和后果均由网站或用户所使用的网络运营商负责。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">(8)</span><span style="font-size:16px;font-family:宋体;color:black;background:white">对于zp.sttts.org.cn为使用者提供便利而设置的外部链接网址，zp.sttts.org.cn并不保证其准确性、安全性和完整性，亦并不代表本网站对其链接内容的认可，请使用者谨慎确认后使用，zp.sttts.org.cn对由此导致的任何损失或伤害不承担任何责任。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">2</span><span style="font-size:16px;font-family:宋体;color:black;background:white">、除了本网址在隐私政策中提出的条款外，使用者理解并同意zp.sttts.org.cn在不公开用户公司名称/用户个人姓名的情况下，可以向第三方提供综合性的非个人化信息资料。除非：</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">(1)</span><span style="font-size:16px;font-family:宋体;color:black;background:white">依照法律、法规、法院命令、监管机构命令的要求；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">(2)</span><span style="font-size:16px;font-family:宋体;color:black;background:white">根据政府行为、监管要求或请求；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">(3)</span><span style="font-size:16px;font-family:宋体;color:black;background:white">因zp.sttts.org.cn其认为系为遵守监管义务或公共目的所需；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">(4)</span><span style="font-size:16px;font-family:宋体;color:black;background:white">为免除访问者在生命、身体或财产方面之急迫危险。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">否则在未经用户事先同意的情况下，zp.sttts.org.cn不会向第三方公开用户的公司名称/个人姓名、地址、电子邮件和电话等个人信息。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">&nbsp;</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0">
            <strong><span style="font-size:16px;font-family:宋体;color:black;background:white">明确的禁止使用：</span></strong>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">zp.sttts.org.cn</span><span style="font-size:16px;font-family:宋体;color:black;background:white">（含网站及手机APP） 只能用于人才招聘相关的合法目的，即个人寻找职业和雇主寻找雇员。zp.sttts.org.cn 明确禁止任何其他非人才招聘相关的用途，并要求所有使用者同意不用于使用zp.sttts.org.cn开展下列任何一种用途：</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(1)</span><span style="font-family:宋体;color:black;background:white">在简历中心公布不完整、虚假或不准确的简历资料，或不是使用者的准确简历(而为他人寻找全职或兼职工作)。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(2)</span><span style="font-family:宋体;color:black;background:white">公布不是招聘信息或简历的资料，如意见、通知、商业广告或其他非招聘信息或简历内容。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(3)</span><span style="font-family:宋体;color:black;background:white">为zp.sttts.org.cn的竞争同行回应职位，并用此方法寻求与雇主联络业务。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(4)</span><span style="font-family:宋体;color:black;background:white">除发布者外，删除或修改其他个人或公司公布的资料。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(5)</span><span style="font-family:宋体;color:black;background:white">擅自打印、复制或以其他方式使用有关雇员的任何个人资料或有关雇主的商业信息。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(6)</span><span style="font-family:宋体;color:black;background:white">未经同意，给公布信息的个人或公司发电子邮件、打电话、寄信或以其他方式进行接触。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">&nbsp;</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <strong><span style="font-size:16px;font-family:宋体;color:black;background:white">网址安全法规：</span></strong>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">禁止使用者违反安全法规，破坏或企图破坏 zp.sttts.org.cn 的安全法规保护措施，包括但不限于：</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(1)</span><span style="font-family:宋体;color:black;background:white">接触未经许可的数据或进入未经许可的服务器、帐户、邮箱或许可第三方接入未经本网站同意的由本网站发布、输送、传播的数据、简历或其他信息等；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(2)</span><span style="font-family:宋体;color:black;background:white">没有得到许可，企图探查、扫描或测试系统或网络的弱点或者破坏安全措施；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(3)</span><span style="font-family:宋体;color:black;background:white">企图干涉对用户及网络的服务，包括但不限于通过超载、“邮件炸弹”或“摧毁”等手段；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(4)</span><span style="font-family:宋体;color:black;background:white">发送促销、产品广告及服务的email；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(5)</span><span style="font-family:宋体;color:black;background:white">伪造TCP/IP数据包名称或部分名称。破坏系统或网络可能导致犯罪。zp.sttts.org.cn 将调查此类破坏行为的发生，并可能干预、和执法当局合作起诉犯此类破坏行为的使用者。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <strong><span style="font-size:16px;font-family:宋体;color:black;background:white">总则：</span></strong>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">严禁从事以下行为：</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(1)</span><span style="font-family:宋体;color:black;background:white">开展违反任何现行法律法规及其他规范性文件的任何活动；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(2)</span><span style="font-family:宋体;color:black;background:white">侵犯他人的版权、商业机密、或其他知识产权，或侵犯了他人的隐私权、出版权或其他个人合法权利；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(3)</span><span style="font-family:宋体;color:black;background:white">利用本网站传送、分发、储存违反任何法律法规及其他规范性文件的内容，包括但不限于属于诽谤、淫秽、威胁、辱骂性、毁损他人或其他非法或者违反社会公序良俗的材料；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(4)</span><span style="font-family:宋体;color:black;background:white">利用zp.sttts.org.cn提供的服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <span style="font-family:宋体;color:black;background:white">(5)</span><span style="font-family:宋体;color:black;background:white">以任何形式使用本网站提供的服务进行任何不利于zp.sttts.org.cn的行为。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <strong><span style="font-size:16px;font-family:宋体;color:black;background:white">暂停使用，中止使用：</span></strong>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">任何一位使用者经研学招聘网确定已违反了有关法律法规、本协议或网站使用规则某一项规定，将收到一份书面警告。如果该使用者在接到前述警告后，以书面形式表示自己再也不会有违犯行为，研学招聘网有权决定是否继续给予暂停或终止使用的处理。然而，如果本网站认为必要时，也可不提出警告而马上暂停或终止对该使用者的服务。如果我们确定某一使用者再次违犯了网络使用规则的任何一项规定，无需再发通知，该使用者立即受到暂停使用或终止使用的处理。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <strong><span style="font-size:16px;font-family:宋体;color:black;background:white">保密：</span></strong>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">除了本网址在信息保密中提出的条款外，使用者理解并同意，zp.sttts.org.cn在不公开用户公司名称/用户个人姓名的情况下，可以向第三方提供综合性的资料。除非依照法律、法规、法院命令、监管机构命令的要求，或根据政府行为、监管要求或请求，或因zp.sttts.org.cn其认为系为遵守监管义务所需时，在没有本人事先同意的情况下，zp.sttts.org.cn不会向第三方公开使用者的姓名、地址、电子邮件和电话等个人信息，但下列情况除外：</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;text-indent:0">
            <span style="font-size:16px;font-family:宋体;color:black">（1）</span><span style="font-size:16px;font-family:宋体;color:black;background:white">根据执法单位之要求或为公共之目的向相关单位提供个人资料；&nbsp;<br/> （2）由于访问者将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露；&nbsp;<br/> （3）由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人资料泄露、丢失、被盗用或被窜改等；&nbsp;<br/> （4）由于与本网站链接的其他网站所造成之个人资料泄露及由此而导致的任何法律争议和后果；&nbsp;<br/> （5）为免除访问者在生命、身体或财产方面之急迫危险。&nbsp;</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">对于以上原因导致的任何损失或伤害，zp.sttts.org.cn不承担任何责任。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">&nbsp;</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <strong><span style="font-size:16px;font-family:宋体;color:black;background:white">风险声明：</span></strong>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">使用者使用本网址及其内信息须自行承担风险。本网址的材料是按&quot;正如……的情况&quot;所提供的，zp.sttts.org.cn对材料不作任何明示的或暗示的保证。除非适用的法律法规有明确规定，zp.sttts.org.cn及其所属网络对销售性的和适合于某一特定目的的一切保证不予承认。zp.sttts.org.cn不能保证材料的特殊目的不受阻挠不出错误，也不能保证错误会得到纠正，也不能保证本网址或制成本网址的材料不含有病毒或其他有害成分。在有关材料的使用或使用结果方面，zp.sttts.org.cn对材料的正确性、准确性、可靠性或其他方面不作出保证或任何说明。使用者(而不是zp.sttts.org.cn)承担一切必要的服务、修理或改正费用。在适用法规不允许暗含保证可免除承担一切费用的范围里，免除上述承担费用不适用于使用者。</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <span style="font-size:16px;font-family:宋体;color:black;background:white">&nbsp;</span>
          </p>
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left">
            <span style="font-size:16px;font-family:宋体;color:#E20000;background:white">&nbsp;</span><span style="font-size:16px;font-family:宋体;color:#E20000;background:white">警告：在使用zp.sttts.org.cn网络时违反本声明及zp.sttts.org.cn其他规定条款将构成对zp.sttts.org.cn权利的侵犯，并可导致zp.sttts.org.cn对违规使用者采取法律行动。</span>
          </p>
          <p>
            <br/>
          </p>
        </div>
      </div>
    </div>
    <footer-div v-if="isshow"></footer-div>
    <orgfooter-div v-else></orgfooter-div>
  </div>
</template>

<script>
  import headerDiv from '../pageMember/components/header'
  import footerDiv from '../pageMember/components/footer'
  import orgheaderDiv from '../pageOrg/components/header'
  import orgfooterDiv from '../pageOrg/components/footer'

  export default {
    data() {
      return {
        content: '',
        isshow: false
      }
    },
    created() {
      // 默认选择北京市
      this.$store.state.selectionAddress = window.sessionStorage.getItem('selectionAddress') ? JSON.parse(window.sessionStorage.getItem('selectionAddress')) : {
        categoryname: "北京市",
        city_id: 110100,
        parentid: 1,
        spell: "beijingshi"
      }
      if(JSON.parse(window.localStorage.getItem('user')) === null) {
        this.isshow = true
      }else{
        JSON.parse(window.localStorage.getItem('user')).user_type !== 2 ? this.isshow = true : this.isshow = false
      }

    },
    methods: {
      getCookie(cname) {
        let name = cname + "="
        let ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i].trim()
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
          }
        }
        return ""
      }
    },
    components: {
      headerDiv,
      footerDiv,
      orgheaderDiv,
      orgfooterDiv
    }
  }
</script>

<style scoped lang="scss">
  .xieyi {
    min-height: 500px;
    padding: 30px 20px;
    background: #fff;
    margin: 30px 0;

    > h2 {
      text-align: center;
      font-size: 20px;
      line-height: 60px;
    }

    .xieyi-content {
      p, div, h1, h2, h3, h4, h5, h6 {
        line-height: 24px;
      }
    }
  }
</style>
